<template>
    <div class="mb-2 mt-3 pl-0" style="background-color: #fff">
        <!-- <div class="headline mb-4">Boxes</div> -->

        <div v-for="(box, index) in distribution.boxes">
            <v-layout row
                ><v-layout column class="ml-2 pl-1">
                    <v-layout row class="ml-0 mb-2 mt-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Box ID
                        </div>
                        <div>{{ box.boxID }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Box #
                        </div>
                        <div>{{ box.boxNum }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Box Size
                        </div>
                        <div>{{ box.boxSize }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Created At
                        </div>
                        <div>{{ box.dateCreated | time }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            House
                        </div>
                        <div>{{ box.house }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Street
                        </div>
                        <div>{{ box.street }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Street Side
                        </div>
                        <div>{{ box.streetSide }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Red
                        </div>
                        <div>{{ box.red }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Yellow
                        </div>
                        <div>{{ box.yellow }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Blue
                        </div>
                        <div>{{ box.blue }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Green
                        </div>
                        <div>{{ box.green }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Label Batch
                        </div>
                        <div>{{ box.labelBatch }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Route
                        </div>
                        <div>{{ box.route }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Truck
                        </div>
                        <div>{{ box.truck }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Dont Alert
                        </div>
                        <div>{{ box.dontAlert }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Scheduled Delivery Date
                        </div>
                        <div>{{ box.scheduledDeliveryDate | date }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Status
                        </div>
                        <div>{{ box.status }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2" v-if="getNotification(box)">
                        <div class="font-weight-medium mr-1 width-200">
                            Notified By
                        </div>
                        <div>{{ getNotification(box).type }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2" v-if="getNotification(box)">
                        <div class="font-weight-medium mr-1 width-200">
                            Notified At
                        </div>
                        <div>{{ getNotification(box).date | time }}</div>
                    </v-layout>
                    <v-layout row class="ml-0 mb-2" v-if="getNotification(box)">
                        <div class="font-weight-medium mr-1 width-200">
                            Notification #
                        </div>
                        <div>
                            {{ getNotification(box).to | phone }}
                        </div>
                    </v-layout>
                </v-layout>
                <v-layout
                    align-end
                    justify-space-between
                    column
                    fill-height
                    class="mb-0 mr-2"
                >
                    <v-btn
                        @click="scan(box)"
                        class="mt-0 mb-3 mr-1"
                        color="success"
                        small
                        dark
                    >
                        Scan
                    </v-btn>
                </v-layout>
            </v-layout>
            <vue-good-table
                class="scan-list"
                styleClass="vgt-table striped"
                :columns="scanColumns"
                :rows="box.scans"
                :search-options="{
                    enabled: false,
                }"
            >
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.isIcon" class="px-0">
                        <v-icon
                            class="px-0"
                            dark
                            :color="
                                props.column.iconColor(
                                    props.row[props.column.field]
                                )
                            "
                            >{{
                                props.column.icon(props.row[props.column.field])
                            }}</v-icon
                        >
                    </span>
                    <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>
            </vue-good-table>
            <v-divider
                class="my-4"
                v-if="index + 1 < distribution.boxes.length"
                :key="index"
            ></v-divider>
        </div>
        <div class="font-weight-medium mt-3 mb-2">
            Notifications
        </div>
        <vue-good-table
            class="scan-list"
            styleClass="vgt-table striped"
            :columns="notificationColumns"
            :rows="distribution.notifications"
            :search-options="{
                enabled: false,
            }"
        >
            <template slot="table-row" slot-scope="props">
                <span>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except, formatPhoneNumber } from "../../utils/helpers.js";

export default {
    props: {
        distribution: Object,
        scan: Function,
        callNotifications: Array,
        smsNotifications: Array,
    },
    data() {
        return {
            scanColumns: [
                {
                    field: "scanType",
                    isIcon: true,
                    template: "icon",
                    alignment: "center",
                    visible: true,
                    allowFiltering: false,
                    allowHeaderFiltering: false,
                    allowHiding: false,
                    allowSearch: false,
                    cssClass: "width-25",
                    headerFilter: {
                        allowSearch: false,
                        groupInterval: undefined,
                        height: undefined,
                        searchMode: "contains",
                        width: undefined,
                    },
                    icon: (value, row) => {
                        switch (value) {
                            case "Delivered":
                                return "mdi-check-circle";
                            case "NotDelivered":
                                return "mdi-close-circle";
                            case "ScanDelete":
                            case "Delete":
                            case "Delete Nothing":
                            case "Delete WasNotScanned":
                                return "mdi-delete";
                            default:
                                return "";
                        }
                    },
                    iconColor: (value, row) => {
                        switch (value) {
                            case "Delivered":
                                return "success";
                            case "NotDelivered":
                                return "#f35123";
                            case "ScanDelete":
                            case "Delete":
                            case "Delete Nothing":
                            case "Delete WasNotScanned":
                                return "#aeb8bf";
                            default:
                                return "";
                        }
                    },
                },

                {
                    sortable: true,
                    label: "Box #",
                    field: "boxNum",
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Date",
                    field: "scanDate",
                    type: "date",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                },
                {
                    sortable: true,
                    label: "ScanType",
                    field: "scanType",
                    hidden: false,
                },
                {
                    sortable: true,
                    label: "GPS Address",
                    field: "gpsAddress",
                    hidden: false,
                },
                {
                    sortable: true,
                    label: "User",
                    field: "userID",
                    hidden: false,
                },
            ],
            notificationColumns: [
                {
                    sortable: false,
                    label: "Date",
                    field: "date",
                    type: "date",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                },
                {
                    sortable: true,
                    label: "Type",
                    field: "type",
                    hidden: false,
                },
                {
                    sortable: true,
                    label: "From",
                    field: "from",
                    hidden: false,
                },
                {
                    sortable: true,
                    label: "To",
                    field: "to",
                    hidden: false,
                },
                {
                    sortable: true,
                    label: "Hangup Cause",
                    field: "hangupCause",
                    hidden: false,
                },
                {
                    sortable: true,
                    label: "Is Retry",
                    field: "isRetry",
                    type: "boolean",
                    formatFn: (value) => (value ? "Yes" : "No"),
                    hidden: false,
                },
            ],
        };
    },
    async created() {},
    computed: {},
    methods: {
        getNotification(box) {
            if (!box.alertedDate) return "";

            const start = moment(box.alertedDate).subtract(3, "seconds");
            const end = moment(box.alertedDate).add(3, "seconds");

            const callNotification = this.callNotifications.find(
                (n) => moment(n.date) > start && moment(n.date) < end
            );
            const smsNotification = this.smsNotifications.find(
                (n) => moment(n.dateTime) > start && moment(n.dateTime) < end
            );

            const notification = callNotification
                ? callNotification
                : smsNotification;

            if (!notification) return;

            notification.date = notification.dateTime
                ? notification.dateTime
                : notification.date;
            notification.type = notification.text ? "TEXT" : "CALL";

            return notification;
        },
        formatPhoneNumber(value) {
            return formatPhoneNumber(value);
        },
    },
};
</script>
<style>
.scan-list .vgt-table {
    border: 1px solid #ddd !important;
}

.scan-list table.vgt-table td {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    padding-left: 8px !important;
    font-weight: 400 !important;
}

.scan-list tr:nth-child(even) {
    background-color: #fff !important;
}
</style>
